var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconUrl02 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#3B3B3B",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15.547 16h1.447v5.224c-.006 1.717-1.298 2.893-3.247 2.893-1.96 0-3.242-1.176-3.247-2.893V16h1.436v5.102c.005 1.01.707 1.729 1.81 1.734 1.105-.005 1.8-.723 1.8-1.734zM18.474 23.996V16h3.003c1.834 0 2.811 1.027 2.817 2.551-.006 1.088-.503 1.894-1.442 2.275l1.729 3.17h-1.602l-1.568-2.927H19.91v2.927zm1.435-4.13h1.348c1.082.005 1.568-.459 1.568-1.315 0-.85-.486-1.347-1.569-1.347H19.91zM25.53 23.996V16h1.436v6.78H30.5v1.216z"
})));
export default SvgIconUrl02;